import React from 'react';
import { Box, Flex, theme, Button } from '@xometry/xometry_loft';
import { Cell } from 'react-table';
import UserInitial from '../../../../components/UserInitialBox';
import { css } from '@emotion/react';

export const ActiveMemberColumns = (
  leaveTeam: VoidFunction,
  emailAddress: string
) => {
  return [
    {
      Header: 'Team Members',
      accessor: 'userData',
      Cell: ({ cell }: { cell: Cell }) => (
        <Flex fontSize="13px">
          <Box marginRight="10px">
            <UserInitial
              fullName={`${cell.value.firstName} ${cell.value.lastName}`}
              role={cell.value.role}
              size={40}
            />
          </Box>
          <Flex flexDirection="column" justifyContent="center">
            <Box fontWeight={theme.fontWeights.semibold}>
              {cell.value.firstName} {cell.value.lastName}
            </Box>
            <Box
              css={css`
                @media (max-width: 52em) {
                  display: none;
                }
              `}
            >
              {cell.value.email}
            </Box>
          </Flex>
        </Flex>
      ),
    },
    {
      Header: 'Date Added',
      accessor: 'date',
    },
    {
      Header: <Flex>Role</Flex>,
      accessor: 'role',
      Cell: ({ cell }: { cell: Cell }) => <Flex>{cell.value}</Flex>,
    },
    {
      Header: () => null,
      accessor: 'email',
      Cell: ({ cell }: { cell: Cell }) =>
        cell.value === emailAddress && (
          <Box minWidth="100px">
            <Button
              link
              color={theme.colors.reds[100]}
              fontSize={['10px', '16px', '16px', '16px']}
              fontWeight={theme.fontWeights.semibold}
              onClick={leaveTeam}
            >
              Leave Team
            </Button>
          </Box>
        ),
    },
  ];
};
